import _throttle from 'lodash.throttle'

const headerEl = document.querySelector('.c-header');

const storeHeaderHeight = (height) => {
  const box = headerEl.getBoundingClientRect()
  document.documentElement.style.setProperty('--page-header-height', `${box.height}px`)
}

const setHeaderTransparency = (enter, scroll) => {
  const mq = window.matchMedia('(min-width: 0px)')
  if (mq.matches === true) {
    const scrollValue = 100;
    const scrollObject = {
      x: window.pageXOffset,
      y: window.pageYOffset,
    };

    if (scroll) {
      if (scrollObject.y > scrollValue) {
        enter = true;
      } else {
        enter = false;
      }
    }

    if (enter) {
      headerEl.classList.add('c-header--hovered');
    } else {
      if (scrollObject.y <= scrollValue) {
        headerEl.classList.remove('c-header--hovered');
      }
    }
  }
}

headerEl.addEventListener('mouseenter', () => {
  setHeaderTransparency(true, false)
});
headerEl.addEventListener('mouseleave', () => {
  setHeaderTransparency(false, false)
});

window.addEventListener('scroll', () => {
  setHeaderTransparency(false, true)
});


window.addEventListener('resize', _throttle(() => storeHeaderHeight(), 500))
window.addEventListener('DOMContentLoaded', storeHeaderHeight, { once: true })
